import "../../styles/styles.css";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const navigate = useNavigate();
  return (
    <div>
      <h1 className="error-text">PAGE NOT FOUND</h1>
      <p className="navigation-text" onClick={() => navigate("/")}>
        Home Page
      </p>
    </div>
  );
};

export default Index;
